export const renderTitle = (item) => {
    if (!item) return "";

    if (item?.mrp !== null && item?.mrp !== undefined) {
        return (
            <div>
                <span className="kg-dark-gray mr-1">
                    <s>₹ {item?.mrp}</s>
                </span>
                -
                <span className="ms-1">₹ {item?.price ?? ""}</span>
            </div>
        );
    }

    return item?.heading || item?.title || "";
};
export const renderPrice = (item) => {
    if (!item) return "";

    if (item?.mrp !== null && item?.mrp !== undefined) {
        return item?.heading || "";
    } 
    else if (!item?.heading || item?.heading === 'null') {
        return `₹${item?.price ?? ""}`;
    }

    return "";
};

export const renderSubtitle = (item) => {
    if (item.heading) {
        return item.subtitle;
    }
    return "";
}

export const renderHeading = (item) => {
    return item.heading ? item.title : item.subtitle;
}